import type { ProntuarioPastSessionRecord } from '../types/prontuarioPastSession';
import { buildProntuarioPastSessionListItems } from './buildProntuarioPastSessionListItems';

const sortSessionsByNumberDesc = (
	sessions: ProntuarioPastSessionRecord[],
): ProntuarioPastSessionRecord[] =>
	[...sessions].sort((left, right) => {
		const leftNum = Number.parseInt(left.sessaoNumero ?? '0', 10);
		const rightNum = Number.parseInt(right.sessaoNumero ?? '0', 10);
		return rightNum - leftNum;
	});

const buildProntuarioSortedSessionsList = ({
	recordSessions,
	platformSessions,
	currentMedicalRecordSessionId,
	currentShortSummary,
	excludePlatformSessionId,
}: {
	recordSessions?: MedicalRecords.MedicalRecordSession[] | null;
	platformSessions?: Sessions.Session[] | null;
	currentMedicalRecordSessionId?: string | null;
	currentShortSummary?: string | null;
	excludePlatformSessionId?: string | null;
}): ProntuarioPastSessionRecord[] => {
	const items = buildProntuarioPastSessionListItems({
		recordSessions,
		platformSessions,
		currentPlatformSessionId: excludePlatformSessionId,
	});

	const shortSummary = currentShortSummary?.trim() || null;
	const enrichedItems =
		currentMedicalRecordSessionId && shortSummary
			? items.map((item) =>
					item.id === currentMedicalRecordSessionId &&
					!item.resumoCurto?.trim()
						? { ...item, resumoCurto: shortSummary }
						: item,
			  )
			: items;

	return sortSessionsByNumberDesc(enrichedItems);
};

const buildPlatformSessionByRecordId = (
	recordSessions: MedicalRecords.MedicalRecordSession[],
	platformSessions: Sessions.Session[] | undefined | null,
): ReadonlyMap<string, Sessions.Session> => {
	const platformSessionById = new Map(
		(platformSessions ?? []).map((platformSession) => [
			platformSession.id,
			platformSession,
		]),
	);
	const map = new Map<string, Sessions.Session>();

	for (const recordSession of recordSessions) {
		const platformSession = platformSessionById.get(
			recordSession.session_id,
		);
		if (platformSession) {
			map.set(recordSession.id, platformSession);
		}
	}

	return map;
};

export { buildPlatformSessionByRecordId, buildProntuarioSortedSessionsList };
